var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  _vm.$initSSP()
  var l0 = _vm.__map(3, function (item, index) {
    var $orig = _vm.__get_orig(item)
    if (_vm.$scope.data.scopedSlotsCompiler === "augmented") {
      _vm.$setSSP("default", {
        item: _vm.list[_vm.swiperList[index]],
        index: _vm.swiperList[index],
      })
    }
    return {
      $orig: $orig,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
  _vm.$callSSP()
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }